module.exports = __webpack_public_path__ + "static/media/bg-pattern.7c5658db.svg";